import React, { useState } from 'react';
import { MessageCircle, Phone, X } from 'lucide-react';
import './FloatingActions.css';
import { FaPhone, FaWhatsapp } from 'react-icons/fa';

const WHATSAPP_NUMBER = '919212552928';
const PHONE_NUMBER = '+919212552928';

// function WhatsAppIcon(props) {
//   return (
//     <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
//       <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
//       <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.85.51 3.65 1.49 5.23L2 22l4.96-1.3a9.84 9.84 0 0 0 5.08 1.39h.01c5.46 0 9.91-4.45 9.91-9.91A9.86 9.86 0 0 0 12.04 2zm5.78 15.69c-.24.69-1.41 1.32-1.95 1.4-.5.08-1.13.11-1.82-.11-.42-.13-.96-.31-1.66-.6-2.92-1.26-4.82-4.19-4.97-4.39-.15-.2-1.19-1.58-1.19-3.01 0-1.43.75-2.13 1.02-2.42.27-.29.59-.36.78-.36.2 0 .39 0 .56.01.18.01.42-.07.65.5.24.58.81 2.01.88 2.16.07.15.12.32.02.51-.09.2-.14.32-.28.49-.14.17-.29.38-.42.51-.14.14-.28.29-.12.57.16.28.71 1.17 1.52 1.9 1.05.94 1.93 1.23 2.21 1.37.28.14.44.12.6-.07.16-.2.7-.81.89-1.09.18-.28.37-.23.62-.14.25.09 1.6.75 1.87.89.27.13.45.2.52.31.07.12.07.66-.17 1.35z"/>
//     </svg>
//   );
// }

export default function FloatingActions() {
  const [open, setOpen] = useState(false);

  return (
    <div className="floating-actions">
      {/* <div className={`fa-options ${open ? 'open' : ''}`}> */}
      <div className={`fa-options open`}>
    
        <a
          href={`tel:${PHONE_NUMBER}`}
          className="fa-btn fa-call"
          aria-label="Call us"
        >
          <Phone size={20} />
          <span className="fa-tooltip">Call +91 92125 52928</span>
          <span className="fa-phone" />
        </a>

            <a
          href={`https://wa.me/${WHATSAPP_NUMBER}?text=Hi%20SHIVKMS%2C%20I%27d%20like%20to%20know%20more%20about%20your%20services.`}
          target="_blank"
          rel="noopener noreferrer"
          className="fa-btn fa-whatsapp"
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp />
          <span className="fa-tooltip">Chat on WhatsApp</span>
          <span className="fa-pulse" />
        </a>
      </div>

      
      {/* <button
        className={`fa-phone-toggle ${open ? 'open' : ''}`}
        onClick={() => setOpen(!open)}
        aria-label={open ? 'Close contact options' : 'Open contact options'}
      >
        {open ? <X /> : <Phone />}
        {!open && <span className="fa-phone" />}
      </button>

      <button
        className={`fa-toggle ${open ? 'open' : ''}`}
        onClick={() => setOpen(!open)}
        aria-label={open ? 'Close contact options' : 'Open contact options'}
      >
        {open ? <X /> : <FaWhatsapp />}
        {!open && <span className="fa-pulse" />}
      </button> */}
    </div>
  );
}
